var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlackLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60766 12.0054L16.6411 18.207C16.8804 18.418 16.996 18.6641 16.988 18.9453C16.9801 19.2266 16.8565 19.4727 16.6172 19.6836C16.378 19.8945 16.0989 20 15.7799 20C15.4609 20 15.1818 19.8945 14.9426 19.6836L7.57416 13.2078C7.38278 13.039 7.23923 12.8492 7.14354 12.6383C7.04785 12.4273 7 12.2164 7 12.0054C7 11.7945 7.04785 11.5836 7.14354 11.3726C7.23923 11.1617 7.38278 10.9718 7.57416 10.8031L14.9426 4.3062C15.1818 4.09526 15.4649 3.99331 15.7919 4.00034C16.1188 4.00737 16.4019 4.11636 16.6411 4.32729C16.8804 4.53823 17 4.78433 17 5.06558C17 5.34683 16.8804 5.59292 16.6411 5.80386L9.60766 12.0054Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlackLarge);
export default __webpack_public_path__ + "static/media/arrow_left_black_large.af72242d3b028bf58e74398ccd2afc66.svg";
export { ForwardRef as ReactComponent };